module.exports = __webpack_public_path__ + "img/err404.7f01050f.png";